import angular from 'angular';
import moment from 'moment';

import templateUrl from './edit-icd-payout-policy-list.component.html';

export const EditIcdPayoutPolicyComponent = {
    controller: EditIcdPayoutPolicyController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        icdCorporation: '<',
        productLines: '<',
        products: '<',
        isAdminView: '<'

    }
};


function EditIcdPayoutPolicyController($q, utilityService, payoutPolicyService,
    productCommissionPolicyService, multiPlayCommissionPolicyService, apexApiUrl) {
    'ngInject';

    const vm = this;
    vm.icdCorporation;
    vm.products;
    vm.productLines;
    vm.$onInit = onInit;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.addPolicy = addPolicy;
    vm.copyPayoutPolicy = copyPayoutPolicy;
    vm.divisionID = 35
    vm.editForm;
    vm.icdCorporationPayoutPolicy;
    vm.isReadOnly = false;
    vm.onSave = onSave;
    vm.removePolicy = removePolicy;
    vm.updatePolicy = updatePolicy;
    vm.validatePolicy = validatePolicy;
    vm.exportPayoutPolicy = exportPayoutPolicy;

    function onInit() {
        vm.loaded = false;
    }

    function onChanges(change) {
        if (change.icdCorporation.currentValue) {
            activate();
        }
    }
    function activate() {
        $q.when(utilityService.showLoading())
            .then(loadInitailData)
            .then(loadData)
            .catch(function (ex) {
                if (ex.status !== 404) {
                    $.winxnetAlertWindow({ message: "Initial load failed: " + utilityService.getExceptionMessage(ex) });
                }
            })

            .then(function () {
                vm.loaded = true;
                utilityService.hideLoading();
            });
    }

    function loadInitailData() {
        vm.icdCorporationPayoutPolicy = null;
        const productCommision = productCommissionPolicyService.retrieveProductCommissionPolicies();
        const getMultiPlayCommissionPolicies = multiPlayCommissionPolicyService.retrieveMultiPlayCommissionPolicies();
        return $q.all([productCommision, getMultiPlayCommissionPolicies])
            .then(function (v) {
                vm.productCommissions = hydrateProductCommissions(v[0], vm.products, vm.productLines);//Hydrating product commissions with product and product lines
                vm.multiPlayCommissions = hydrateMultiPlayCommissions(v[1], vm.productLines);//Hydrating multiplay commissions with product lines
            });
    }

    function loadData() {
        vm.isReadOnly = false;
        const getIcdPayoutPolicies = payoutPolicyService.retrieveIcdCorporationPayoutPolicy(vm.icdCorporation.Id)
            .catch(function (ex) {
                if (ex.status === 404 && !vm.isAdminView) {
                    vm.isReadOnly = true;
                    // Owner doesn't have a policy of their own, so show the division policy.
                    return payoutPolicyService.retrieveDivisionPayoutPolicy(vm.divisionID);
                }
                // Otherwise, propagate error forward.
                throw ex;
            });
        return $q.all([getIcdPayoutPolicies])
            .then(function (v) {

                vm.icdCorporationPayoutPolicy = v[0];
                if (vm.icdCorporationPayoutPolicy) {
                    vm.icdCorporationPayoutPolicy.PayoutPolicies.forEach(hydrateIcdPayoutPolicy);
                }

                vm.icdCorporationPayoutPolicy.PayoutPolicies = vm.icdCorporationPayoutPolicy.PayoutPolicies
                    .filter(p => p.CanModify)
                //Update the active policy
                updateActivePolicy(vm.icdCorporationPayoutPolicy);
            });
    }

    function hydrateIcdPayoutPolicy(policy) {
        //Adding Rep policy within the icd policy object
        const repPayoutPolicy = vm.icdCorporationPayoutPolicy.RepPayoutPolicies.filter(function (repPayoutPolicy) {
            const repPolicyStartDate = repPayoutPolicy.ActiveStart ? repPayoutPolicy.ActiveStart.getTime() : null;
            const repPolicyEndDate = repPayoutPolicy.ActiveEnd ? repPayoutPolicy.ActiveEnd.getTime() : null;
            const policyStartDate = policy.ActiveStart ? policy.ActiveStart.getTime() : null;
            const policyEndtDate = policy.ActiveEnd ? policy.ActiveEnd.getTime() : null;
            return repPolicyStartDate === policyStartDate && repPolicyEndDate === policyEndtDate
        });

        if (repPayoutPolicy[0] != null) {
            policy.RepPayoutSplittingModifier = repPayoutPolicy[0].PayoutSplittingModifier;
            policy.RepPayoutPolicyID = repPayoutPolicy[0].PayoutPolicyID;
            policy.RepMultiPlayCommissionPayoutPolicies = repPayoutPolicy[0].MultiPlayCommissionPayoutPolicies;
            policy.RepProductCommissionPayoutPolicies = repPayoutPolicy[0].ProductCommissionPayoutPolicies;
            policy.CanModify = true;
        } else {

            policy.CanModify = false;
        }

        const fromDate = policy.ActiveStart;
        const toDate = policy.ActiveEnd;
        //Filter commissions by division
        const filteredProductCommissions = vm.productCommissions.filter(function (event) {
            return Number(vm.divisionID) === Number(event.Product.DivisionID)
        });
        const filteredMultiPlayCommissions = vm.multiPlayCommissions.filter(function (event) {
            return Number(vm.divisionID) === Number(event.DivisionID)
        });
        policy.ProductCommissions = fillProductCommissionPolicies(filteredProductCommissions, fromDate,
            toDate, policy.ProductCommissionPayoutPolicies, policy.RepProductCommissionPayoutPolicies,
            policy.SplittingModifierType, policy.PayoutSplittingModifier, policy.RepPayoutSplittingModifier)
        const multiPlayCommissionPolicies = fillMultiPlayCommissionPolicies(filteredMultiPlayCommissions,
            policy.MultiPlayCommissionPayoutPolicies, policy.RepMultiPlayCommissionPayoutPolicies, fromDate,
            toDate, policy.SplittingModifierType, policy.PayoutSplittingModifier, policy.RepPayoutSplittingModifier)
        policy.MultiPlayCommissions = filterPoliciesByDate(multiPlayCommissionPolicies, fromDate, toDate);
    }

    function fillProductCommissionPolicies(productCommissionPolicies, fromDate, toDate, icdSource, repSource,
        splitModifierType, icdSplitModifier, repSplitModifier) {

        const source = angular.copy(productCommissionPolicies);
        source.forEach(function (policy) {
            policy.SuggestedPolicy = filterPoliciesByDate(policy.Archives, fromDate, toDate);
            let icdPayoutModified = false;
            if (policy.PayoutAmount && policy.DefaultPayoutAmount !== policy.PayoutAmount) {
                icdPayoutModified = true;
            }
            let repPayoutModified = false;
            if (policy.RepPayoutAmount && policy.DefaultRepPayoutAmount !== policy.RepPayoutAmount) {
                repPayoutModified = true;
            }
            //Payout Amount for ICD
            const payoutAmount = getPayoutAmount(icdSource, policy.ProductID, policy.ProductLineID);
            //Default payout amount calculated by applying split percentage to the product commission amount
            policy.DefaultPayoutAmount = policy.SuggestedPolicy.length > 0 ? calculatePayout(
                policy.SuggestedPolicy[0].Amount, icdSplitModifier, splitModifierType) : null;
            policy.PayoutAmount = icdPayoutModified ? policy.PayoutAmount : payoutAmount != null
                ? payoutAmount : policy.DefaultPayoutAmount;
            policy.isPayoutModified = icdPayoutModified || payoutAmount != null;

            //Payout Amount for Rep
            const repPayoutAmount = getPayoutAmount(repSource, policy.ProductID, policy.ProductLineID);
            //Default rep payout amount calculated by applying split percentage to the product commission amount
            policy.DefaultRepPayoutAmount = policy.SuggestedPolicy.length > 0 ? calculatePayout(
                policy.DefaultPayoutAmount, repSplitModifier, splitModifierType) : null;
            policy.RepPayoutAmount = repPayoutModified ? policy.RepPayoutAmount : repPayoutAmount != null
                ? repPayoutAmount : policy.DefaultRepPayoutAmount;
            policy.isRepPayoutModified = repPayoutModified || repPayoutAmount != null;
        });
        return source.filter(function (policy) {
            return policy.Product != null && policy.ProductLine != null
        });
    }

    function fillMultiPlayCommissionPolicies(multiPlayCommissionPolicies, icdSource, repSource,
        fromDate, toDate, splitModifierType, icdSplitModifier, repSplitModifier) {

        const source = angular.copy(multiPlayCommissionPolicies);
        source.forEach(function (policy) {
            policy.MultiPlayCommissionPolicyProductLines.forEach(function (line) {

                //Disable the input box if policy does not lie on the given start and end date(this will be only for multiplay commissions)
                if (isPolicyExist(policy, fromDate, toDate)) {

                    let icdPayoutModified = false;
                    if (line.PayoutAmount && line.DefaultPayoutAmount !== line.PayoutAmount) {
                        icdPayoutModified = true;
                    }
                    const payoutAmount = getMultiplayPayoutAmount(icdSource, policy.Id, line.ProductLineID);
                    //Default payout amount calculated by applying split percentage to the multi play commission amount
                    line.DefaultPayoutAmount = calculatePayout(line.Amount, icdSplitModifier, splitModifierType);
                    line.PayoutAmount = icdPayoutModified ? line.PayoutAmount : payoutAmount != null
                        ? payoutAmount : line.DefaultPayoutAmount;
                    line.isPayoutModified = icdPayoutModified || payoutAmount != null;
                } else {
                    line.disablePayout = true;
                }
                if (isPolicyExist(policy, fromDate, toDate)) {

                    let repPayoutModified = false;
                    if (line.RepPayoutAmount && line.DefaultRepPayoutAmount !== line.RepPayoutAmount) {
                        repPayoutModified = true;
                    }
                    const repPayoutAmount = getMultiplayPayoutAmount(repSource, policy.Id, line.ProductLineID);
                    //Default rep payout amount calculated by applying split percentage to the multi play commission amount
                    line.DefaultRepPayoutAmount = calculatePayout(line.DefaultPayoutAmount,
                        repSplitModifier, splitModifierType);
                    line.RepPayoutAmount = repPayoutModified ? line.RepPayoutAmount : repPayoutAmount != null
                        ? repPayoutAmount : line.DefaultRepPayoutAmount;
                    line.isRepPayoutModified = repPayoutModified || repPayoutAmount != null;
                } else {
                    line.disableRepPayout = true;
                }
            });

        });
        return source;
    }


    function hydrateProductCommissions(productCommissions, products, productLines) {
        productCommissions.forEach(function (policy) {

            policy.Product = products.filter(function (product) {
                return product.ProductID === policy.ProductID;
            })[0];
            policy.ProductLine = productLines.filter(function (productLine) {
                return productLine.ProductLineID === policy.ProductLineID;
            })[0];

        });
        return productCommissions;
    }

    function hydrateMultiPlayCommissions(multiPlayCommissions, productLines) {
        const multiplayCommissionsList = [];
        multiPlayCommissions.forEach(function (policy) {
            policy.Archives.forEach(function (archive) {
                archive.Name = policy.Name;
                archive.DivisionID = policy.DivisionID;
                archive.Division = policy.Division;
                archive.Count = policy.Count;
                archive.MultiPlayCommissionPolicyID = policy.Id;
                archive.MultiPlayCommissionPolicyProductLines.forEach(function (line) {
                    line.ProductLine = productLines.filter(function (productLine) {
                        return productLine.ProductLineID === line.ProductLineID;
                    })[0];
                });
                multiplayCommissionsList.push(archive);
            });
        });
        return multiplayCommissionsList;
    }

    function filterPoliciesByDate(archives, startDate, endDate) {
        let policies = [];

        if (!startDate && !endDate) {
            policies = archives;
        }
        //All policies after the given start date
        if (startDate && !endDate) {
            policies = archives.filter(function (event) {
                return (event.ActiveInstalledStart == null || (event.ActiveInstalledEnd == null ||
                    startDate <= event.ActiveInstalledEnd))
                    && (event.ActiveOrderStart == null || (event.ActiveOrderEnd == null ||
                        startDate <= event.ActiveOrderEnd))
            });
        }
        //All policies till the given end date
        if (!startDate && endDate) {
            policies = archives.filter(function (event) {
                return (event.ActiveInstalledStart == null || (event.ActiveInstalledEnd == null ||
                    endDate >= event.ActiveInstalledEnd))
                    && (event.ActiveOrderStart == null || (event.ActiveOrderEnd == null ||
                        endDate >= event.ActiveOrderEnd))
            });
        }
        //All policies between the given start and end date
        if (startDate != null && endDate != null) {
            policies = archives.filter(function (event) {
                return (startDate >= event.ActiveInstalledStart && (event.ActiveInstalledEnd == null ||
                    event.ActiveInstalledEnd >= startDate) ||
                    endDate >= event.ActiveInstalledStart && (event.ActiveInstalledEnd == null ||
                        event.ActiveInstalledEnd >= endDate))
                    && (startDate >= event.ActiveOrderStart && (event.ActivOrdereEnd == null ||
                        event.ActiveOrderEnd >= startDate) ||
                    endDate >= event.ActiveOrderStart && (event.ActiveOrderEnd == null ||
                        event.ActiveOrderEnd >= endDate))
            });
        }
        return policies.sort(function (a, b) {
            return a.ActiveOrderStart < b.ActiveOrderStart ? -1 : 1;
        });
    }

    function isPolicyExist(policy, startDate, endDate) {
        let exists = true;


        if (!startDate && !endDate) {
            exists = true;
        }
        if (startDate && !endDate) {
            exists = (policy.ActiveInstalledStart == null || (policy.ActiveInstalledEnd == null ||
                startDate <= policy.ActiveInstalledEnd))
                && (policy.ActiveOrderStart == null || (policy.ActiveOrderEnd == null ||
                    startDate <= policy.ActiveOrderEnd))
        }

        if (!startDate && endDate) {
            exists = (policy.ActiveInstalledStart == null || (policy.ActiveInstalledEnd == null ||
                endDate >= policy.ActiveInstalledEnd))
                && (policy.ActiveOrderStart == null || (policy.ActiveOrderEnd == null ||
                    endDate >= policy.ActiveOrderEnd))
        }

        if (startDate != null && endDate != null) {
            exists = (startDate >= policy.ActiveInstalledStart && (policy.ActiveInstalledEnd == null ||
                policy.ActiveInstalledEnd >= startDate) ||
                endDate >= policy.ActiveInstalledStart && (policy.ActiveInstalledEnd == null ||
                    policy.ActiveInstalledEnd >= endDate))
                && (startDate >= policy.ActiveOrderStart && (policy.ActiveOrderEnd == null ||
                    policy.ActiveOrderEnd >= startDate) ||
                    endDate >= policy.ActiveOrderStart && (policy.ActiveOrderEnd == null ||
                        policy.ActiveOrderEnd >= endDate));
        }

        return exists;
    }

    function getPayoutAmount(source, productID, productLineID) {
        if (source) {
            const payoutPolicyCommision = source.filter(function (event) {
                return event.ProductID === productID && event.ProductLineID === productLineID
            });

            if (payoutPolicyCommision.length > 0) {
                return payoutPolicyCommision[0].PayoutAmount;
            }
        }

    }

    function getMultiplayPayoutAmount(source, multiPlayCommissionPolicyArchiveID, productLineID) {
        if (source) {
            const payoutPolicyCommision = source.filter(function (event) {
                return event.MultiPlayCommissionPolicyArchiveID === multiPlayCommissionPolicyArchiveID
            });

            if (payoutPolicyCommision.length > 0) {
                const multiPlayProductLines = payoutPolicyCommision[0].ProductLines.filter(function (event) {
                    return event.ProductLineID === productLineID;
                })[0];
                return multiPlayProductLines ? multiPlayProductLines.PayoutAmount : null;
            }
        }
    }

    function calculatePayout(amount, splittingModifier, splittingModifierType) {
        let payoutAmount;
        switch (splittingModifierType) {
            case "Percent":
                payoutAmount = amount * splittingModifier;
                break;
            case "Number":
                payoutAmount = splittingModifier;
                break;
        }
        return payoutAmount;
    }

    function updateDatesOrder(payoutPolicyHistory, currentPolicy) {

        const nextPolicy = payoutPolicyHistory.reduce(function (nextPolicy, other) {
            if (other === currentPolicy || moment(other.ActiveStart).isSameOrBefore(currentPolicy.ActiveStart)) {
                return nextPolicy
            }

            if (!nextPolicy || moment(nextPolicy.ActiveStart).isSameOrAfter(other.ActiveStart)) {
                return other;
            } else {
                return nextPolicy;
            }
        }, null);
        if (nextPolicy && !currentPolicy.ActiveEnd) {
            currentPolicy.ActiveEnd = moment(nextPolicy.ActiveStart).subtract(1, "day").toDate();
        }

        const previousPolicy = payoutPolicyHistory.reduce(function (previousPolicy, other) {
            if (other === currentPolicy || moment(other.ActiveStart).isSameOrAfter(currentPolicy.ActiveStart)) {
                return previousPolicy
            }

            if (!previousPolicy || moment(previousPolicy.ActiveStart).isSameOrBefore(other.ActiveStart)) {
                return other;
            } else {
                return previousPolicy;
            }
        }, null);

        if (previousPolicy && !previousPolicy.ActiveEnd) {
            previousPolicy.ActiveEnd = moment(currentPolicy.ActiveStart).subtract(1, "day").toDate();
        }

    }

    function validatePolicy(currentPolicy) {

        updateDatesOrder(vm.icdCorporationPayoutPolicy.PayoutPolicies, currentPolicy)
        if (checkDatesOrder(vm.icdCorporationPayoutPolicy)) {
            updatePolicy(currentPolicy);
            updateActivePolicy(vm.icdCorporationPayoutPolicy);
        }
    }

    function checkDatesOrder(icdPayoutPolicy) {

        const isValidHistoryOrder = icdPayoutPolicy.PayoutPolicies.reduce(function (ag, policy, i, a) {
            if (!ag.valid) {
                return ag;
            }
            const valid = !(
                policy.ActiveStart && policy.ActiveEnd && policy.ActiveStart > policy.ActiveEnd // Doesn't end before it starts.
            || !policy.ActiveEnd && i !== 0 // Doesn't omit start date unless it's the first entry.
            || !policy.ActiveStart && i !== a.length - 1 // Doesn't omit end date unless it's the last entry.
            || ag.previousStart && policy.ActiveEnd >= ag.previousStart); // Doesn't overlap with a previous entry (in descending order)

            return {
                previousStart: policy.ActiveStart,
                previousEnd: policy.ActiveEnd,
                valid: valid
            };
        }, { previousStart: null, previousEnd: null, valid: true }).valid;

        if (vm.editForm) {
            vm.editForm.$setValidity("historyOrder", isValidHistoryOrder);
        }
        return isValidHistoryOrder;
    }

    function addPolicy() {
    //Create  master
        if (!vm.icdCorporationPayoutPolicy && vm.icdCorporation) {


            vm.icdCorporationPayoutPolicy = {
                IsNew: true,
                IcdCorporationID: vm.icdCorporation.Id,
                PayoutPolicies: []
            };

        }

        const policy = {

            IsNew: true,
            ActiveStart: null,
            ActiveEnd: null,
            PayoutPolicyID: 0,
            PayoutSplittingModifier: 0,
            RepPayoutPolicyID: 0,
            RepPayoutSplittingModifier: 0,
            SplittingModifierType: 'Percent',
        };

        const filteredProductCommissions = vm.productCommissions.filter(function (event) {
            return Number(vm.divisionID) === Number(event.Product.DivisionID)
        });
        const filteredMultiPlayCommissions = vm.multiPlayCommissions.filter(function (event) {
            return Number(vm.divisionID) === Number(event.DivisionID)
        });

        policy.ProductCommissions = fillProductCommissionPolicies(filteredProductCommissions,
            policy.ActiveStart, policy.ActiveEnd, [], [], policy.SplittingModifierType,
            policy.PayoutSplittingModifier, policy.RepPayoutSplittingModifier)
        const multiPlayCommissionPolicies = fillMultiPlayCommissionPolicies(filteredMultiPlayCommissions,
            [], [], policy.ActiveStart, policy.ActiveEnd, policy.SplittingModifierType,
            policy.PayoutSplittingModifier, policy.RepPayoutSplittingModifier)
        policy.MultiPlayCommissions = filterPoliciesByDate(multiPlayCommissionPolicies,
            policy.ActiveStart, policy.ActiveEnd);
        vm.icdCorporationPayoutPolicy.PayoutPolicies.unshift(policy);

    }

    function updatePolicy(policy) {
    //Update the polcies amount
        const filteredProductCommissions = policy.ProductCommissions.filter(function (event) {
            return vm.divisionID === event.Product.DivisionID
        });
        const filteredMultiPlayCommissions = policy.MultiPlayCommissions.filter(function (event) {
            return vm.divisionID === event.DivisionID
        });
        policy.ProductCommissions = fillProductCommissionPolicies(filteredProductCommissions,
            policy.ActiveStart, policy.ActiveEnd, policy.ProductCommissionPayoutPolicies,
            policy.RepProductCommissionPayoutPolicies, policy.SplittingModifierType,
            policy.PayoutSplittingModifier, policy.RepPayoutSplittingModifier)
        const multiPlayCommissionPolicies = fillMultiPlayCommissionPolicies(filteredMultiPlayCommissions,
            policy.MultiPlayCommissionPayoutPolicies, policy.RepMultiPlayCommissionPayoutPolicies,
            policy.ActiveStart, policy.ActiveEnd, policy.SplittingModifierType, policy.PayoutSplittingModifier,
            policy.RepPayoutSplittingModifier)
        policy.MultiPlayCommissions = filterPoliciesByDate(multiPlayCommissionPolicies,
            policy.ActiveStart, policy.ActiveEnd);
    }

    function removePolicy(policy) {
        if (confirm("Are you sure you want to delete the policy ?")) {
            const index = vm.icdCorporationPayoutPolicy.PayoutPolicies.indexOf(policy);
            vm.icdCorporationPayoutPolicy.PayoutPolicies.splice(index, 1);
            if (checkDatesOrder(vm.icdCorporationPayoutPolicy)) {
                updateActivePolicy(vm.icdCorporationPayoutPolicy);
            }
        }
    }

    function updateActivePolicy(policy) {

        const activePayoutPolicy = policy.PayoutPolicies.sort(function (a, b) {
            return a.ActiveStart > b.ActiveStart ? -1 : 1;
        })[0];

        if (activePayoutPolicy) {
            policy.ActivePayoutPolicy = activePayoutPolicy;
        } else {
            policy.ActivePayoutPolicy = null;
        }

    }

    function copyPayoutPolicy(policy) {
        if (confirm("This action will undo all changes to the current policy. Are you sure you want to continue?")) {
            const index = vm.icdCorporationPayoutPolicy.PayoutPolicies.indexOf(policy);
            const previousPolicy = angular.copy(vm.icdCorporationPayoutPolicy.PayoutPolicies[index + 1]);
            policy.PayoutSplittingModifier = previousPolicy.PayoutSplittingModifier
            policy.RepPayoutSplittingModifier = previousPolicy.RepPayoutSplittingModifier
            policy.SplittingModifierType = previousPolicy.SplittingModifierType
            policy.MultiPlayCommissions = previousPolicy.MultiPlayCommissions
            policy.ProductCommissions = previousPolicy.ProductCommissions;
            policy.MultiPlayCommissionPayoutPolicies = previousPolicy.MultiPlayCommissionPayoutPolicies
            policy.ProductCommissionPayoutPolicies = previousPolicy.ProductCommissionPayoutPolicies;
            policy.RepProductCommissionPayoutPolicies = previousPolicy.RepProductCommissionPayoutPolicies
            policy.RepMultiPlayCommissionPayoutPolicies = previousPolicy.RepMultiPlayCommissionPayoutPolicies;
        }
    }

    function onSave() {

        utilityService.showLoading();
        //Map the division payout policy to the request object & make it ready to send
        const request = {
            IcdCorporationID: vm.icdCorporationPayoutPolicy.IcdCorporationID,
            IsNew: vm.icdCorporationPayoutPolicy.IsNew,
            RepPayoutPolicies: [],
            PayoutPolicies: []
        };
        vm.icdCorporationPayoutPolicy.PayoutPolicies.forEach(function (policy) {
            const payoutPolicy = {
                ActiveStart: policy.ActiveStart,
                ActiveEnd: policy.ActiveEnd,
                PayoutPolicyID: policy.PayoutPolicyID,
                PayoutSplittingModifier: policy.PayoutSplittingModifier,
                SplittingModifierType: policy.SplittingModifierType
            }
            mapProductCommissionPolices(policy.ProductCommissions, payoutPolicy, false);
            mapMultiPlayCommissionPolices(policy.MultiPlayCommissions, payoutPolicy, false);

            const repPayoutPolicy = {
                ActiveStart: policy.ActiveStart,
                ActiveEnd: policy.ActiveEnd,
                PayoutPolicyID: policy.RepPayoutPolicyID,
                PayoutSplittingModifier: policy.RepPayoutSplittingModifier,
                SplittingModifierType: policy.SplittingModifierType
            }
            mapProductCommissionPolices(policy.ProductCommissions, repPayoutPolicy, true);
            mapMultiPlayCommissionPolices(policy.MultiPlayCommissions, repPayoutPolicy, true);

            request.PayoutPolicies.push(payoutPolicy);
            request.RepPayoutPolicies.push(repPayoutPolicy);
        });
        let saveRequest;
        if (request.IsNew) {
            saveRequest = payoutPolicyService.createIcdCorporationPayoutPolicy(request)
        } else {
            saveRequest = payoutPolicyService.updateIcdCorporationPayoutPolicy(
                vm.icdCorporationPayoutPolicy.IcdCorporationID, request)
        }

        saveRequest
            .catch(function (ex) {
                utilityService.hideLoading();
                console.error(ex);
                $.winxnetAlertWindow({ message: "Saving failed: " + utilityService.getExceptionMessage(ex) });
            })
            .then(function () {

                utilityService.hideLoading();
                activate();
            });
    }

    function mapProductCommissionPolices(productCommissionPayoutPolicies, payoutPolicy, isRepPolicy) {

        const policies = productCommissionPayoutPolicies.filter(function (policy) {
            return isRepPolicy && policy.RepPayoutAmount != null
            && policy.RepPayoutAmount !== policy.DefaultRepPayoutAmount
            || !isRepPolicy && policy.PayoutAmount != null
            && policy.PayoutAmount !== policy.DefaultPayoutAmount;
        }).map(
            function (policy) {
                return {
                    ProductID: policy.ProductID,
                    ProductLineID: policy.ProductLineID,
                    PayoutAmount: isRepPolicy ? policy.RepPayoutAmount : policy.PayoutAmount,
                    PayoutPolicyID: payoutPolicy.PayoutPolicyID
                };
            });
        payoutPolicy.ProductCommissionPayoutPolicies = policies;
    }

    function mapMultiPlayCommissionPolices(multiCommissionPayoutPolicies, payoutPolicy, isRepPolicy) {
        const policies = multiCommissionPayoutPolicies
            .filter(function (policy) {
                const productLines = policy.MultiPlayCommissionPolicyProductLines.filter(function (productLine) {
                    return isRepPolicy && productLine.RepPayoutAmount != null
                    && productLine.RepPayoutAmount !== productLine.DefaultRepPayoutAmount
                    || !isRepPolicy && productLine.PayoutAmount != null
                    && productLine.PayoutAmount !== productLine.DefaultPayoutAmount
                });
                return productLines.length > 0;
            }).map(
                function (policy) {
                    const productLines = policy.MultiPlayCommissionPolicyProductLines
                        .reduce(function (lines, productLine) {
                            if (isRepPolicy && productLine.RepPayoutAmount != null
                            && productLine.RepPayoutAmount !== productLine.DefaultRepPayoutAmount
                            || !isRepPolicy && productLine.PayoutAmount != null
                            && productLine.PayoutAmount !== productLine.DefaultPayoutAmount) {
                                lines.push({
                                    ProductLineID: productLine.ProductLineID,
                                    PayoutAmount: isRepPolicy ? productLine.RepPayoutAmount : productLine.PayoutAmount,
                                });
                            }
                            return lines;
                        }, []);
                    return {
                        MultiPlayCommissionPolicyArchiveID: policy.Id,
                        MultiPlayCount: policy.Count,
                        PayoutPolicyID: payoutPolicy.PayoutPolicyID,
                        ProductLines: productLines
                    };

                });
        payoutPolicy.MultiPlayCommissionPayoutPolicies = policies;
    }

    function exportPayoutPolicy(policy) {
        const params = {
            DivisionID: vm.divisionID,//For corporation we are only considering rogers for now TODO : Add a dropdown for divisions
            PayoutPolicyID: policy.PayoutPolicyID,
            RepPayoutPolicyID: policy.RepPayoutPolicyID
        };
        const queryString = utilityService.queryStringify(params);
        window.location.href = apexApiUrl + "payout-policy-report.xlsx"
        + queryString;
    }

}
